import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon } } });
export default ClientProvider;
